import request from '@/router/axios'
// 我的付款、总代采购分页
export function getMyPaymentList (query) {
  return request({
    url: '/api/generalItemOrderDetail/listByCode',
    method: 'get',
    params: query
  })
}
// 店铺采购报表分页
export function shopItemOrderDetailListByCode (query) {
    return request({
      url: '/api/shopItemOrderDetail/listByCode',
      method: 'get',
      params: query
    })
}
// 装机总报表报表分页
export function shopStatislistByCode (query) {
  return request({
    url: '/api/shopStatis/listByCode',
    method: 'get',
    params: query
  })
}
// 租赁保证金报表分页
export function listByCode (query) {
  return request({
    url: '/api/shopDeposit/listByCode',
    method: 'get',
    params: query
  })
}
// 总收购机时款报表分页
export function listByTime (query) {
  return request({
    url: '/api/shopBuyMachinehour/listByTime',
    method: 'get',
    params: query
  })
}
// 总售出机时报表分页
export function generalSaleMachinehour (query) {
  return request({
    url: '/api/generalSaleMachinehour/listByCode',
    method: 'get',
    params: query
  })
}

export function generalBuyMachinehour(query) {
  return request({
    url: '/api/generalBuyMachinehour/listByCode',
    method: 'get',
    params: query
  })
}

export function shopInformationPage(query) {
  return request({
    url: '/api/shopInformation/page',
    method: 'get',
    params: query
  })
}

export function visitInformationPage(query) {
  return request({
    url: '/api/visitInformation/page',
    method: 'get',
    params: query
  })
}

export function shopInformationDetail(query) {
  return request({
    url: `/api/shopInformation/${query.id}`,
    method: 'get',
    params: query
  })
}

// 商品分页查询
export function getGoodsList (query) {
    return request({
      url: '/api/generalItemOrderDetail/item/page',
      method: 'get',
      params: query
    })
}
// 档案分页查询 (店铺、总代、区代)
export function getArchiveList (query) {
  return request({
    url: '/api/common/archive/page',
    method: 'get',
    params: query
  })
}
